import { esContent } from "@/i18n/content.es";
import type { Messages } from "@/i18n/types";

export const esMessages: Messages = {
  actions: {
    backToHome: "Volver al inicio",
    call: "Llamar",
    closeMenu: "Cerrar menú de navegación",
    consultation: "Consulta",
    copyLink: "Copiar enlace",
    copyLinkSuccess: "Enlace copiado al portapapeles",
    email: "Correo",
    openMenu: "Abrir menú de navegación",
    share: "Compartir",
    switchLanguage: "Cambiar idioma",
    tryAgain: "Intentarlo de nuevo",
  },
  admin: {
    emailPlaceholder: "nombre@ejemplo.com",
    emptyDescription:
      "Las nuevas consultas aparecerán aquí cuando alguien envíe el formulario público.",
    emptyTitle: "Aún no hay consultas",
    eyebrow: "Panel del estudio",
    eventTypeLabel: "Tipo de evento",
    filterAllStatuses: "Todos los estados",
    filterStatusLabel: "Filtrar por estado",
    inquiriesDescription:
      "Revisa consultas, necesidades de planificación y datos de contacto en un solo lugar.",
    inquiriesLoadError:
      "El panel no pudo cargar las consultas ahora mismo. Intenta recargar la página.",
    inquiriesLoading: "Cargando consultas...",
    inquiriesTitle: "Consultas de eventos enviadas",
    inquiryDetailsTitle: "Detalles de la consulta",
    inquiryListTitle: "Lista de consultas",
    inquiryListSupport:
      "Filtra o selecciona una consulta para revisar los detalles.",
    loginButton: "Iniciar sesión",
    loginDescription:
      "Usa las credenciales del estudio para revisar las consultas de eventos.",
    loginError: "El correo o la contraseña no son correctos.",
    loginPending: "Iniciando sesión...",
    loginTitle: "Acceso del estudio",
    statusArchived: "Archivada",
    statusInProgress: "En progreso",
    statusLabel: "Estado",
    statusNew: "Nueva",
    statusSaveError:
      "No se pudo actualizar el estado de la consulta ahora mismo. Inténtalo otra vez.",
    statusSavePending: "Guardando estado...",
    statusSaveSuccess: "Estado actualizado.",
    logoutButton: "Cerrar sesión",
    passwordLabel: "Contraseña",
    passwordPlaceholder: "Escribe tu contraseña",
    receivedAtLabel: "Recibida",
  },
  common: {
    address: "Dirección",
    description: "Descripción",
    email: "Correo electrónico",
    loading: "Cargando…",
    mobileNavigation: "Navegación móvil",
    name: "Nombre",
    optional: "Opcional",
    phone: "Teléfono",
    primaryNavigation: "Navegación principal",
    required: "Obligatorio",
    skipToContent: "Saltar al contenido principal",
    toggleNav: "Alternar navegación",
  },
  consent: {
    accept: "Aceptar analítica",
    decline: "Rechazar",
    description:
      "Usamos analítica respetuosa con la privacidad para ver cómo se usa el sitio de JPL Atelier. Sin cookies ni seguimiento entre sitios.",
    learnMore: "Leer la nota de privacidad",
    title: "Ayúdanos a mejorar el sitio web",
  },
  errors: {
    boundaryEyebrow: "Error inesperado",
    boundaryHint:
      "Recarga la página. Si sigue pasando, contacta al equipo del sitio web.",
    boundaryTitle: "Algo salió mal al cargar esta página.",
    notFoundIntro:
      "La página que buscas pudo haberse movido, cambiado o no estar publicada.",
    notFoundSeoTitle: "404",
    notFoundTitle: "No se pudo encontrar esta página.",
    unknownLocale: "Idioma desconocido. Se usará inglés por defecto.",
  },
  footer: {
    apoloLogoAlt: "Apolo Inventions",
    credit: "Desarrollado por Apolo Inventions",
    follow: "Seguir",
  },
  localeSwitcher: {
    englishLabel: "EN",
    spanishLabel: "ES",
  },
  share: {
    email: "Compartir por correo",
    linkedin: "Compartir en LinkedIn",
    native: "Compartir…",
    twitter: "Compartir en X",
  },
  sitemap: {
    jumpToSection: "Ir a la sección",
  },
  content: esContent,
};
